import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MppPage } from './mpp.page';
import { BrowserPageTitle } from '@shared/constants/browser-page-title.enum';
import { PATHS } from '@shared/constants/paths';
import { AuthConnectGuardService } from '@shared/services';
import { MppGuardService } from '@shared/services/authentication/mpp-guard.service';
import { RecipeDetailResolverService } from './pages/recipe-detail/services/recipe-detail-resolver.service';

const routes: Routes = [
  {
    path: '',
    component: MppPage,
    data: { title: BrowserPageTitle.mpp },
    canActivate: [MppGuardService],
  },
  {
    path: PATHS.RECIPES,
    loadChildren: () =>
      import('./pages/recipes/recipes.module').then(m => m.RecipesPageModule),
    data: { title: BrowserPageTitle.recipes },
    canActivate: [MppGuardService],
  },
  {
    path: PATHS.RECIPE_DETAILS,
    loadChildren: () =>
      import('./pages/recipe-detail/recipe-detail.module').then(
        m => m.RecipeDetailPageModule,
      ),
    data: { title: BrowserPageTitle.recipeDetails },
    canActivate: [MppGuardService],
    resolve: {
      data: RecipeDetailResolverService,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MppPageRoutingModule {}
